import { AllocatedAvailability } from "services/motorpoint/getEarliestBookingSlots";

type BookingType = "collection" | undefined;

export type ResolvedBookingSlot = {
    bookingType: BookingType;
    date: Date;
    siteId: number;
    price: number;
};

const bookingSlotResolver = (
    data: AllocatedAvailability & { siteId: number }
): ResolvedBookingSlot => {
    return {
        bookingType: "collection",
        date: new Date(data.FirstSlot),
        siteId: data.siteId,
        price: data.Price,
    };
};

export default bookingSlotResolver;
